import { theme, toRem } from '../../styles';
import styled from 'styled-components';

export const StyledCardCarousel = styled.div<{
  cardHeight: string;
}>(
  ({ cardHeight = '' }) => `
  @media ${theme.mediaQuery.xl} {
    display: block;
  }
  .aem-container:first-child {
    margin-left: 0;
  }
  .glide {
    &__track {
      overflow: hidden;
      height : ${cardHeight} !important;
      padding-top: ${toRem(0)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        white-space: normal;
        display: flex;
        list-style: none;
        overflow: hidden;
        padding: 0;
        margin: 0;
        .aem-container {
          padding: 0;
        }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        white-space: normal;
        .aem-container {
          padding: 0;
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
      .carouselControlType1 {
        div {
          align-items: center;
        }
        .right-arrow {
          right: -1rem;
          @media ${theme.mediaQuery.sm} {
            right: -1.25rem;
          }
        }
        .left-arrow {
          left: -1rem;
          @media ${theme.mediaQuery.sm} {
            left: -1.25rem;
          }
        }
        #control-nav button {
          opacity: 0.7;
          &.active {
            height: ${toRem(10)};
            width: ${toRem(10)};
            transform: scale(1);
            opacity: 1;
          }
        }
      }
      .carouselControlImageType {
        .right-arrow,
        .left-arrow {
          opacity: unset !important;
          background-color: rgba(0, 0, 0, 0.5);
          &:focus-visible {
            outline: ${toRem(3)} solid;
            outline-offset: ${toRem(3)};
          }
        }
        .right-arrow {
          right: 1rem;
        }
        .left-arrow {
          left: 1rem;
        }
        #control-nav {
          position: absolute;
          bottom: 55px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: ${toRem(20)};
          padding: ${toRem(8)};
          button {
            background-color: #ccc;
            &.active {
              height: ${toRem(7)};
              width: ${toRem(7)};
              background-color: #ffffff;
            }
          }
        }
      }
    }
  }
  .glide--swipeable {
    cursor: default;
  }
  .mini-arrow {
    position: unset !important;
    background: transparent !important;
    color: ${theme.colors.black} !important;
    box-shadow: none !important;

    &:focus-visible {
      outline: ${toRem(2)} solid;
    }
  }
  .hide-arrow {
    opacity: 0.4 !important;
    display: flex !important;
  }
`
);
